import { useEffect } from "react";
import { isMobile, isMobileOnly, isTablet } from "react-device-detect";
import { useTranslation, Trans } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ButtonComponent } from "src/components/share";
import { IConSuccessComponent } from "src/components/images";
import "./index.scss";
import { Link } from "react-router-dom";
import useAuth from "src/hooks/useAuth";
import { ELanguage } from "src/interfaces";

interface IProps {
  data: string | null;
  isResale?: boolean;
  stylesSuccess?: React.CSSProperties;
}
function HotelRevervationSuccessComponent({
  data,
  isResale,
  stylesSuccess,
}: IProps) {
  const { auth }: any = useAuth();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const language = localStorage.getItem("lang");

  return (
    <div
      className={
        isMobileOnly
          ? "HotelRevervationSuccessStyleMobile"
          : isTablet
          ? "HotelRevervationSuccessStyleTablet"
          : "HotelRevervationSuccessStyle"
      }
      style={{ width: isMobile ? "100%" : "66%", ...stylesSuccess }}
    >
      <div className="wrap-success">
        <div className="img-success">
          <IConSuccessComponent />
        </div>
        <div className="thank">{t("hote_reservation.thank_success")}</div>
        {data && (
          <div
            className={`text-2 ${
              language === ELanguage.JA ? "w-435-auto" : ""
            }`}
          >{`${t("hote_reservation.success.reservationNo")} ${data}`}</div>
        )}
        <div className="text-3">{t("reservation.input.success.remind")}</div>
        <div
          style={{
            display: "flex",
            gap: 16,
            marginTop: 48,
            justifyContent: "center",
            alignItems: "center",
            flexDirection: isMobileOnly ? "column" : "row",
          }}
        >
          <ButtonComponent
            buttonLabel="Top Page"
            buttonProps={{
              style: {
                width: 200,
                borderRadius: 4,
                backgroundColor: "#3F9BC0",
                fontSize: 16,
              },
            }}
            onClick={() => navigate("/")}
          />

          <ButtonComponent
            buttonLabel="My Page"
            buttonProps={{
              style: { width: 200, borderRadius: 4, fontSize: 16 },
            }}
            onClick={() =>
              navigate(
                isResale
                  ? "/authed/resale/my-page?reservation_list_tab_active=0"
                  : `/authed/hotel/my-page`
              )
            }
          />
        </div>
        <div className="text-4">
          <Trans
            i18nKey={
              auth?.user
                ? `reservation.input.booking.success.link.authed`
                : `reservation.input.booking.success.link.not.authed`
            }
            components={{
              link1: (
                <Link
                  to={`/authed/hotel/reservation/detail/${data}?menu=2&reservation_list_tab_active=0`}
                />
              ),
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default HotelRevervationSuccessComponent;
